import { hexToRgb } from './';

export const Circle = ({
  x = 0,
  y = 0,
  radius = 10,
  color = "#181818",
  isFilled = false,
} = {}) => ({
  x,
  y,
  radius,
  color,
  isFilled,
  appearValue: 0,
  shrinkValue: radius,
  draw({ radius = this.radius, ctx } = {}) {
    ctx.beginPath();
    ctx.arc(this.x, this.y, radius, 0, 2 * Math.PI);
    ctx.strokeStyle = this.color;
    ctx.lineWidth = .9;
    ctx.stroke();
    isFilled && (ctx.fillStyle = color) && ctx.fill();
    return this;
  },
  appear(ctx) {
    if (this.appearValue < this.radius) {
      this.appearValue += 2;
      this.draw({ radius: this.appearValue, ctx });
    } else {
      this.draw({ ctx });
    }
    return this;
  },
  disappear(ctx) {
    if (this.shrinkValue > 0) {
      this.shrinkValue -= 2;
      this.draw({ radius: this.shrinkValue, ctx });
    }
    
    return this;
  },
  resetShrink(){
    this.shrinkValue = this.radius
  }, 
  resetAppear(){
    this.appearValue = 0;
  },
  setPos({ x, y }) {
    this.x = x;
    this.y = y;
    return this;
  }
});

export const Point = ({ x, y, radius, isFilled } = {}) => ({
  center: Circle({
    x: x,
    y: y,
    radius: radius,
    isFilled: isFilled
  }),
  discCount: 35,
  disc: [],
  distance: 3,
  createDisc() {
    for (let i = 0; i < 360; i = i + 360 / this.discCount) {
      const angle = i + 360 / this.discCount;
      const x = this.center.x + this.center.radius * Math.cos(-angle * Math.PI / 180) * this.distance;
      const y = this.center.y + this.center.radius * Math.sin(-angle * Math.PI / 180) * this.distance;
      this.disc.push({
        satellite: Circle({ x, y, radius: .5, isFilled: true, color: '#54545e' }),
        angle
      });
    }
  },
  drawDisc() {
    if (this.center.appearValue >= this.center.radius) {
      this.disc.forEach(satellite => {
        satellite.satellite.draw({ ctx: this.ctx });

      });
    }
  },
  drawCross(ctx) {
    const width = 9;
    const height = 2;
    ctx.beginPath();
    ctx.fillStyle = "#FFF";
    ctx.fillRect(x - height / 2 + .5, y - width / 2 + .5, height, width);
    ctx.fillRect(x - width / 2 + .5, y - height / 2 + .5, width, height);
  },
  init(ctx) {
    this.center.appear(ctx);
    this.drawCross(ctx);
  }
});

export const Wave = ({
  x,
  y,
  apex = 10,
  color = "#181818",
  speed = 1,
  r = 0
} = {}) => ({
  apex: apex,
  color: color,
  incrementer: .02,
  opacity: .4,
  r: r,
  x: x,
  y: y,
  isDraw: false,
  draw(ctx) {
    const color = hexToRgb(this.color);

    if (this.r < apex) {
      this.incrementer += .04;
      this.r += (.7 / this.incrementer) * speed;
    } else {
      this.r = 0;
      this.opacity = .4;
      this.incrementer = 0.1;
      this.isDraw = true;
    }

    this.opacity > 0 && (this.opacity -= 0.005 * speed);


    // Only start drawing after a cycle. First ease is behaving  
    // atypical for unknown reasons.
    if (this.isDraw) {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI);
      ctx.strokeStyle =
        "rgba(" +
        color.r +
        ", " +
        color.g +
        ", " +
        color.b +
        ", " +
        this.opacity +
        ")";
      ctx.stroke();
    }


  },
  setPos({ x, y }) {
    this.x = x;
    this.y = y;
  }

});




// WEBPACK FOOTER //
// ./src/components/util/draw.js